export default {
    install(Vue) {
        Vue.prototype.$pwaInstaller = {
            data: Vue.observable({
                deferredPrompt: null,
                showInstallPrompt: false,
                isMobileDevice: false,
                isPWAInstalled: false,
                showInstallBanner: false,
                canInstall: false,
                isIOS: false
            }),

            init() {
                console.log('PWA Installer: Initializing...');
                
                // Check if mobile device and iOS
                this.data.isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                this.data.isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
                
                console.log('PWA Installer: Device detection', {
                    isMobileDevice: this.data.isMobileDevice,
                    isIOS: this.data.isIOS,
                    userAgent: navigator.userAgent
                });

                // Initial installation check
                this.checkIfPWAInstalled();

                // Listen for display mode changes
                window.matchMedia('(display-mode: standalone)').addEventListener('change', () => {
                    console.log('PWA Installer: Display mode changed');
                    this.checkIfPWAInstalled();
                });

                // PWA installation prompt (only for supported browsers)
                if (!this.data.isIOS) {
                    window.addEventListener('beforeinstallprompt', (e) => {
                        console.log('PWA Installer: Before install prompt event received');
                        // Prevent Chrome 67 and earlier from automatically showing the prompt
                        e.preventDefault();
                        // Save the event for later use
                        this.data.deferredPrompt = e;
                        this.data.canInstall = true;
                    });
                }

                window.addEventListener('appinstalled', () => {
                    console.log('PWA Installer: App installed event received');
                    this.data.showInstallPrompt = false;
                    this.data.showInstallBanner = false;
                    this.data.deferredPrompt = null;
                    this.data.canInstall = false;
                    this.checkIfPWAInstalled();
                });

                // Show banner only if mobile device and not installed
                if ((this.data.isMobileDevice || this.data.isIOS) && !this.data.isPWAInstalled) {
                    console.log('PWA Installer: Setting up banner display timer');
                    setTimeout(() => {
                        this.data.showInstallBanner = true;
                        console.log('PWA Installer: Banner should be visible now', {
                            showInstallBanner: this.data.showInstallBanner,
                            isPWAInstalled: this.data.isPWAInstalled,
                            isMobileDevice: this.data.isMobileDevice,
                            isIOS: this.data.isIOS
                        });
                        // Force a reactivity update
                        this.data = { ...this.data };
                    }, 2000);
                }
            },

            checkIfPWAInstalled() {
                // Check if app is installed as PWA
                const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
                const isIOSStandalone = window.navigator.standalone === true;
                const isInFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
                const isInMinimalUI = window.matchMedia('(display-mode: minimal-ui)').matches;
                
                this.data.isPWAInstalled = isStandalone || isIOSStandalone || isInFullscreen || isInMinimalUI;
                
                console.log('PWA Installer: Installation check', {
                    isStandalone,
                    isIOSStandalone,
                    isInFullscreen,
                    isInMinimalUI,
                    isPWAInstalled: this.data.isPWAInstalled
                });
                
                // Hide banner if installed
                if (this.data.isPWAInstalled) {
                    this.data.showInstallBanner = false;
                }
            },

            async installPWA() {
                console.log('PWA Installer: Install PWA called');
                
                if (this.data.isIOS) {
                    console.log('PWA Installer: Showing iOS instructions');
                    this.showInstallInstructions();
                    return;
                }

                if (!this.data.deferredPrompt) {
                    console.log('PWA Installer: No installation prompt available');
                    return;
                }

                try {
                    console.log('PWA Installer: Showing installation prompt');
                    // Show installation prompt
                    await this.data.deferredPrompt.prompt();
                    
                    // Wait for user response
                    const choiceResult = await this.data.deferredPrompt.userChoice;
                    console.log('PWA Installer: User choice', choiceResult);
                    
                    if (choiceResult.outcome === 'accepted') {
                        console.log('PWA Installer: User accepted the install prompt');
                    } else {
                        console.log('PWA Installer: User dismissed the install prompt');
                    }
                } catch (error) {
                    console.error('PWA Installer: Error showing install prompt:', error);
                } finally {
                    this.data.deferredPrompt = null;
                    this.data.canInstall = false;
                }
            },

            showInstallInstructions() {
                console.log('PWA Installer: Showing installation instructions');
                this.data.showInstallBanner = false; // Hide banner before showing instructions
                
                // Show device-specific instructions
                if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                    alert(Vue.prototype.$t('pwa-install-message') + '\n\n' + Vue.prototype.$t('pwa-install-ios-steps'));
                } else if (/Android/i.test(navigator.userAgent)) {
                    alert(Vue.prototype.$t('pwa-install-message') + '\n\n' + Vue.prototype.$t('pwa-install-android-steps'));
                } else {
                    alert(Vue.prototype.$t('pwa-install-message'));
                }

                // Show banner again after 5 seconds
                setTimeout(() => {
                    if (!this.data.isPWAInstalled) {
                        this.data.showInstallBanner = true;
                        console.log('PWA Installer: Banner should be visible again');
                    }
                }, 5000);
            }
        };
    }
}; 